import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';
import { Appraisal ,AppraisalState } from './appraisalTypes';

export const createSelfappraisal = createAsyncThunk(
    'performance/createappraisal',
    async (data: any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/performance/appraisal', data);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create Apprasial');
      }
    }
  );

export const createpersonalgoal = createAsyncThunk(
    'performance/createappliedappraisal',
    async (data : any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/performance/personalgoal', data);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create Appraisal');
      }
    }
  );


  export const fetchAllappraisal = createAsyncThunk(
    'performance/fetchAllappraisal',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/performance/appraisal');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Appraisal');
        }
    }
);


export const fetchappraisalById = createAsyncThunk(
    'performance/fetchRoleApprasialById',
    async ( appraisalId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/performance/appraisal/${appraisalId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Apprasial');
        }
    }
);


export const deleteappraisal = createAsyncThunk(
    'performance/deleteapprasial',
    async (appraisalId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/performance/appraisal/${appraisalId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete Apprasial');
        }
    }
);

export const updateAppraisal = createAsyncThunk<any , {Appraisal: number; data: any}, { rejectValue: string }>(
    'performance/updateappraisal',
    async ({Appraisal , data}: {Appraisal : Number; data: Partial<any>}, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.put(`/performance/apprasial/${Appraisal}`, data)
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create Role-indicator');
      }
    }
  ); 

export const updateappliedappraisal = createAsyncThunk<any , {id: number; data: any}, { rejectValue: string }>(
    'performance/updateappliedappraisal',
    async ({id , data}: {id : Number; data: Partial<any>}, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.put(`/performance/appliedappraisal/${id}`, data)
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create Role-indicator');
      }
    }
  );

  export const fetchAllappliedappraisal = createAsyncThunk(
    'performance/fetchAllappraisal',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/performance/appliedappraisal');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Appraisal');
        }
    }
);